import React, { useEffect, useState } from 'react'
import Switch from 'react-switch';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { DatePicker } from 'antd';
import { getAllData, postUsersData, verifytoken } from '../../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../../_actions/loader.actions';
import { formatDateyearmonthday, getDateCombination, isImageValidPng } from '../../../../commonClass/CommonValidation'
import { ConfirmationModal } from '../../../../../customControl/ConfirmationModal';
import CustomTable from '../../../../../customControl/CustomTable';
import { ImageDelete, ImageUpload } from '../../../../../ImageUpload/ImageCommon';
import dayjs from 'dayjs';
import { ClearLocalStorage, GetLocalStorage } from '../../../../commonClass/Session';
import CommonFilter from '../../../../../customControl/CommonFilter';

const APIMerchandisingHotel = ({ useradd, useredit, userexport }) => {
    const dispatch = useDispatch();

    const [contryList, setCountryList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [hotelList, setHotelList] = useState([]);

    const [dropdownData, setDropdownList] = useState([]);
    const [getDataList, setGetListData] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [editDisable, setEditDisable] = useState(false);
    const [formError, setFormError] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [deletedImage, setDeletedImage] = useState([]);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [isEditOrView, setIsEditOrView] = useState(false)

    const [formValue, setFormValue] = useState({
        HotelMerchandisingId: 0,
        MerchandisingTypeId: 0,
        CountryCode: "",
        CountryName: "",
        CityCode: '',
        CityName: "",
        HotelCode: "",
        HotelName: "",
        HotelPrice: '',
        CheckInDate: null,
        CheckOutDate: "",
        ImageName: "",
        ImagePath: "",
        HotelStarRating: "FourStar",
        IsActive: false,
        UserId: 0,
        type: 'add'
    })

    const getAllHotelCountryList = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const res = await getAllData('/master/v1/gethotelcountrylist');
            if (res.status) {
                setCountryList([...res?.data?.countryList?.map(el => ({
                    label: el?.name,
                    value: el?.code
                }))]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end())
    }

    const getData = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const res = await getAllData('/master/v1/getflightmerchandisingconfiguration');
            if (res.status) {
                setDropdownList({
                    merchandisingTypeList: res?.data?.merchandisingTypeList?.map(el => ({
                        label: el?.MerchandisingName,
                        value: el?.MerchandisingId
                    }))
                });
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end())
    }

    useEffect(() => {
        const fetchCityList = async () => {
            dispatch(loaderActions.start());

            try {
                const statusoftoken = await verifytoken();

                if (!statusoftoken) {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                    return;
                }

                const res = await postUsersData('/master/v1/gethotelcitylist', {
                    CountryCode: formValue.CountryCode,
                });

                if (res?.status) {
                    const cityList = res.data?.cityList?.map(el => ({
                        label: el?.name,
                        value: el?.code,
                    })) || [];
                    setCityList(cityList);
                }
            } catch (error) {
                console.error('Error fetching city list:', error);
                dispatch({ type: 'ALERTING', message: 'Something went wrong. Please try again.' });
            } finally {
                dispatch(loaderActions.end());
            }
        };

        if (formValue.CountryCode) {
            fetchCityList();
        }
    }, [formValue.CountryCode]);

    useEffect(() => {
        const fetchCityList = async () => {
            dispatch(loaderActions.start());

            try {
                const statusoftoken = await verifytoken();

                if (!statusoftoken) {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                    return;
                }

                const res = await postUsersData('/master/v1/hoteltbohotelcodelist', {
                    "CityCode": formValue?.CityCode,
                    "IsDetailedResponse": false
                });

                if (res?.status) {
                    const hotelList = res.data?.map(el => ({
                        label: el?.hotelName,
                        value: el?.hotelCode,
                        hotelRating: el?.hotelRating ? el?.hotelRating?.toString() : ""
                    })) || [];
                    setHotelList(hotelList);
                }
            } catch (error) {
                console.error('Error fetching city list:', error);
                dispatch({ type: 'ALERTING', message: 'Something went wrong. Please try again.' });
            } finally {
                dispatch(loaderActions.end());
            }
        };

        if (formValue.CityCode) {
            fetchCityList();
        }
    }, [formValue.CityCode]);

    useEffect(() => {
        const fetchCityList = async () => {
            dispatch(loaderActions.start());

            try {
                const statusoftoken = await verifytoken();

                if (!statusoftoken) {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                    return;
                }
                let obj = {
                    CheckIn: formValue?.CheckInDate,
                    CheckOut: formValue?.CheckOutDate,
                    HotelCodes: formValue?.HotelCode,
                    GuestNationality: formValue?.CountryCode,
                    PaxRooms: [
                        {
                            Adults: 1,
                            Children: 0,
                            ChildrenAges: null
                        }
                    ],
                    ResponseTime: 0,
                    IsDetailedResponse: false,
                    Filters: {
                        Refundable: false,
                        NoOfRooms: 1,
                        MealType: 0,
                        OrderBy: 0,
                        StarRating: 0,
                        HotelName: formValue?.HotelName
                    }
                }

                const res = await postUsersData('/master/v1/gethotelpricebyhotelcode', obj);

                if (res?.status) {
                    setFormValue({
                        ...formValue,
                        HotelPrice: res.data?.hotelResult?.[0]?.rooms?.[0]?.totalFare ? res.data?.hotelResult?.[0]?.rooms?.[0]?.totalFare : ''
                    })
                }
            } catch (error) {
                dispatch({ type: 'ALERTING', message: 'Something went wrong. Please try again.' });
            } finally {
                dispatch(loaderActions.end());
            }
        };

        if (formValue.HotelCode && formValue?.CheckInDate && !isEditOrView && formValue?.MerchandisingTypeId < 3) {
            fetchCityList();
        };

    }, [formValue.HotelCode, formValue?.CheckInDate]);

    const getDataAll = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const data = await getAllData(`/master/v1/gethotelmerchandisinglist`);
            if (data?.status) {
                setGetListData(data?.data)
                setFilterList(data?.data)
            }
            else {
                setGetListData([])
                setFilterList([])
            }
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end())
    }

    const onChange = (name, value) => {
        setFormError({});
        setEditDisable(false);
        setIsEditOrView(false)

        if (name === 'MerchandisingTypeId') {
            setFormValue({
                ...formValue, [name]: value,
                CountryCode: value === 1 ? 'IN' : '', CountryName: value === 1 ? 'India' : '',
                CityCode: 0, CityName: 0, HotelCode: '', HotelName: '', HotelStarRating: '',
                HotelPrice: formValue?.MerchandisingTypeId === 3 ? 0 : null
            });

        } else if (name === 'CountryCode') {

            setFormValue({
                ...formValue,
                [name]: value.value, CountryName: value?.label, CityCode: 0, CityName: '',
                HotelCode: '', HotelName: '', HotelStarRating: '', HotelPrice: formValue?.MerchandisingTypeId === 3 ? 0 : null
            });
        } else if (name === 'CityCode') {
            setFormValue({
                ...formValue, [name]: value.value, CityName: value?.label,
                HotelCode: '', HotelName: '', HotelStarRating: '', HotelPrice: formValue?.MerchandisingTypeId === 3 ? 0 : null
            });
        } else if (name === 'CheckInDate') {
            setFormValue({
                ...formValue,
                [name]: value,
                CheckOutDate: formatDateyearmonthday(new Date(new Date(value).setDate(new Date(value).getDate() + 1))),
                HotelCode: '', HotelName: '', HotelStarRating: '', HotelPrice: formValue?.MerchandisingTypeId === 3 ? 0 : null
            });
        } else if (name === 'HotelCode') {
            setFormValue({
                ...formValue,
                [name]: value.value, HotelName: value?.label, HotelStarRating: String(value?.hotelRating),
                HotelPrice: formValue?.MerchandisingTypeId === 3 ? 0 : null
            });
        }
        else {
            setFormValue({ ...formValue, [name]: value });
        }
    }

    const handleUploadImageLoad = (e) => {
        setEditDisable(false)
        setFormError({});
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files[0];
            const filename = getDateCombination(files?.name);
            setDeletedImage([...deletedImage, formValue?.ImagePath])
            setFormValue({
                ...formValue,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/hotel/DomesticAndInternational/${filename}`,
                ImageFile: files,
            })
        }
        else {
            setFormError({
                ...formError, 'ImageName': 'Only PNG file type is accepted.'
            });
        }
        e.target.value = null
    }

    const handleisActive = (e) => {
        if (formValue?.type === 'add') {
            setFormValue({
                ...formValue, IsActive: e
            })
            setIsEditOrView(false)
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue({ ...formValue, IsActive: !formValue.IsActive })
            setIsEditOrView(false)
            setFormError({});
            setEditDisable(false);
        }
        setModalShow(false);
    }

    const checkValidation = () => {
        let errorMessages = {};
        let isError = true;

        if (formValue?.MerchandisingTypeId === 0) {
            errorMessages['MerchandisingTypeId'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue?.MerchandisingTypeId > 0 && formValue?.CountryCode === '') {
            errorMessages['CountryCode'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (formValue?.CityCode === 0) {
            errorMessages['CityCode'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }

        if (formValue?.CheckInDate === null && formValue?.MerchandisingTypeId !== 0) {
            errorMessages['CheckInDate'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (!formValue?.ImagePath) {
            errorMessages['ImageName'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        else if (formValue?.ImageFile) {
            const files = formValue?.ImageFile;
            let fileSize = files.size / 1024;
            fileSize = fileSize / 1024
            if (!isImageValidPng(files?.name) && files) {
                errorMessages['ImageName'] = 'Only PNG file type is accepted.'
                isError = false;
            } else if (fileSize > 5) {
                errorMessages['ImageName'] = 'Cannot upload file that exceeds 5 MB.'
                isError = false;
            }
        }
        if (((!formValue?.HotelPrice) && formValue?.CityCode > 0 && formValue?.CheckInDate != null && formValue?.MerchandisingTypeId < 3)) {
            errorMessages['HotelPrice'] = ' Cannot leave blank, please select valid city.'
            isError = false;
        }
        if (formValue?.HotelCode <= 0) {
            errorMessages['HotelCode'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }

        setFormError(errorMessages);
        return isError;
    }

    const onSubmitData = async () => {
        const isValid = checkValidation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                dispatch(loaderActions.start());
                let userid = GetLocalStorage();
                formValue.UserId = userid?.userMasterID
                let imageupload = true
                formValue?.ImageFile &&
                    await ImageUpload(`CMS/Merchandising/hotel/DomesticAndInternational/`, formValue?.ImageName, formValue?.ImageFile).then((res) => {
                        if (!res) {
                            dispatch({ type: 'ALERTING', message: 'There was an issue uploading the image. Please try again after some time.' })
                            imageupload = false
                        }
                    });
                if (imageupload) {
                    const data = await postUsersData('/master/v1/insertorupdatehotelmerchandising', {
                        ...formValue,
                        CheckInDate: formValue.CheckInDate,
                        CheckOutDate: formValue.CheckOutDate,
                        UserId: userid?.userMasterID,
                    });
                    if (data.status) {
                        deletedImage?.length > 0 && deletedImage?.forEach(async (deletedImagePath) => await ImageDelete(deletedImagePath));
                        onClearButton();
                        getDataAll();
                        dispatch({ type: 'ALERTING', message: data.message })
                        dispatch(loaderActions.end());
                    }
                    else {
                        dispatch(loaderActions.end());
                        dispatch({ type: 'ALERTING', message: data.message })
                    }
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const onClearButton = () => {
        setFormError({});
        setEditDisable(false);
        setSerachDisable(false);
        setFormValue({
            HotelMerchandisingId: 0,
            MerchandisingTypeId: 0,
            CountryCode: "",
            CountryName: "",
            CityCode: '',
            CityName: "",
            HotelCode: "",
            HotelName: "",
            HotelPrice: '',
            CheckInDate: null,
            CheckOutDate: "",
            ImageName: "",
            ImagePath: "",
            HotelStarRating: "FourStar",
            IsActive: false,
            type: 'add'
        })
    }

    const onEditorView = async (data, type) => {
        if (type === 'view') {
            setSerachDisable(true)
        }
        onClearButton();
        setEditDisable(true)
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const el = await getAllData(`/master/v1/gethotelmerchandisingbyid?hotelMerchandisingId=${data?.HotelMerchandisingId}`);
            setFormError({});
            if (el?.status) {
                setFormValue({ ...el?.data?.[0], type });
                setIsEditOrView(true)
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Merchandising Type',
            key: "MerchandisingType",
            sortable: true,
            float: "left",
            selector: (data) => data?.MerchandisingType,
        },
        {
            name: 'City',
            key: "CityName",
            sortable: true,
            float: "left",
            selector: (data) => data?.CityName,
        },
        {
            name: 'Hotel name',
            key: "HotelName",
            sortable: true,
            float: "left",
            selector: (data) => data?.HotelName,
        },
        {
            name: 'Booking Date',
            key: "CheckInDate",
            sortable: true,
            float: "left",
            selector: (data) => data?.CheckInDate,
        },
        {
            name: 'Lowest Price',
            key: "HotelPrice",
            sortable: true,
            float: "left",
            selector: (data) => data?.HotelPrice,
        },
        {
            name: 'Active',
            key: "Status",
            sortable: true,
            float: "left",
            selector: (data) => data?.Status,
        },
        {
            name: 'Edit',
            selector: data => <button
                type='button'
                className='border-0 p-0 bg-body set_disableclr'
                onClick={() => onEditorView(data, 'edit')}
                disabled={!useredit}
            >
                <i class="fa fa-edit eye-icon"></i>
            </button>
        },
        {
            name: 'View',
            selector: data => <button
                type='button'
                className='border-0 p-0 bg-body set_disableclr'
                onClick={() => onEditorView(data, 'view')}
            >
                <i className="fa fa-eye" ></i>
            </button>
        }
    ]

    useEffect(() => {
        dispatch(loaderActions.start());
        getAllHotelCountryList();
        getDataAll();
        getData();
    }, [])

    return (
        <>
            <form action="" >
                <div className="mb-3 row mx-1">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="row">
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Merchandising Type</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="SupplierId"
                                            className="dropdown select_dropdown"
                                            options={dropdownData?.merchandisingTypeList}
                                            value={dropdownData?.merchandisingTypeList?.filter((val) => (val.value === formValue?.MerchandisingTypeId))}
                                            onChange={(e) => onChange('MerchandisingTypeId', e?.value)}
                                            isDisabled={formValue?.type === 'view' ? true : false || formValue?.type === 'edit'}
                                            isSearchable
                                        />
                                        {formError?.MerchandisingTypeId && <p className='text-danger text-start mb-0'>{formError?.MerchandisingTypeId}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Country</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="CountryCode"
                                            name='CountryCode'
                                            className="dropdown select_dropdown"
                                            options={formValue?.MerchandisingTypeId === 2 ? contryList.filter((val) => val.value !== 'IN') : contryList}
                                            value={contryList?.filter((val) => (val.value === formValue?.CountryCode))}
                                            onChange={(val) => onChange('CountryCode', val)}
                                            isDisabled={
                                                formValue?.type === 'view' ? true : false
                                                    || formValue?.MerchandisingTypeId < 2
                                                    || formValue?.type === 'edit'}
                                            isSearchable
                                        />
                                        {formError?.CountryCode && formValue?.MerchandisingTypeId > 0 && <p className='text-danger text-start mb-0'>{formError?.CountryCode}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">City</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="City"
                                            name='CityCode'
                                            className="dropdown select_dropdown"
                                            options={cityList}
                                            value={cityList?.filter((val) => (val.value === formValue?.CityCode))}
                                            onChange={(val) => onChange('CityCode', val)}
                                            isDisabled={formValue?.type === 'view' ? true : false || formValue?.CountryCode ? false : true}
                                            isSearchable
                                        />
                                        {formError?.CityCode && formValue?.CountryCode && <p className='text-danger text-start mb-0'>{formError?.CityCode}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Image</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <div className="input-group">
                                            <input
                                                type="file"
                                                name='ImageNameHotel'
                                                id="ImageName-hotel-id"
                                                className="form-control btn_add"
                                                accept=".png"
                                                onChange={(e) => handleUploadImageLoad(e)}
                                                disabled={formValue?.type === 'view' ? true : false}
                                            />
                                            <label className="input-group-text" htmlFor="ImageName-hotel-id">Browse</label>
                                        </div>
                                        {formValue?.ImageName && <p className='text-start mb-0'>{formValue?.ImageName}</p>}
                                        {formError?.ImageName && <p className='text-danger text-start mb-0'>{formError?.ImageName}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Booking Date</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <DatePicker
                                            className='antd_input w-100'
                                            format='DD/MM/YYYY'
                                            placeholder="DD/MM/YYYY"
                                            minDate={dayjs(formatDateyearmonthday(new Date()), "YYYY-MM-DD")}
                                            value={(formValue?.CheckInDate !== null && formValue?.CheckInDate !== '') ? dayjs(formatDateyearmonthday(formValue?.CheckInDate), 'YYYY/MM/DD') : null}
                                            onChange={(e) => onChange('CheckInDate', e ? `${formatDateyearmonthday(e?.$d)}` : null, false)}
                                            disabled={formValue?.type === 'view' ? true : false || formValue?.CityCode ? false : true}
                                        />
                                        {formError?.CheckInDate && formValue?.CityCode !== 0 && <p className='text-danger text-start mb-0'>{formError?.CheckInDate}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Hotel List for 4-5 Rating</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <Select
                                            id="hotelList"
                                            className="dropdown select_dropdown"
                                            options={hotelList}
                                            value={hotelList?.filter((val) => (val.value === formValue?.HotelCode))}
                                            onChange={(val) => onChange('HotelCode', val)}
                                            isDisabled={formValue?.type === 'view' ? true : false
                                                || formValue?.CityCode === 0 ? true : false ||
                                            formValue?.CheckInDate === null}
                                            isSearchable
                                        />
                                        {formError?.HotelCode && formValue?.CheckInDate !== null && formValue?.CityCode !== 0 && <p className='text-danger text-start mb-0'>{formError?.HotelCode}</p>}
                                    </div>
                                </div>
                            </div>

                            {formValue?.MerchandisingTypeId < 3 && <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Lowest Price</label>
                                    </div>
                                    <div className="col-lg-8 mb-1 col-md-12">
                                        <input type="text" id="FlightNo" className="form-control"
                                            name="LowestPrice"
                                            defaultValue={formValue?.HotelPrice}
                                            value={formValue?.HotelPrice}
                                            maxLength={8}
                                            disabled
                                            placeholder="Lowest Price"
                                        />
                                    </div>
                                </div>
                            </div>}

                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-12 mb-1">
                                        <label for="inputPassword6" className="col-form-label">Active</label>
                                    </div>
                                    <div className="col-auto col-lg-8" disabled={false}>
                                        <Switch
                                            onChange={handleisActive}
                                            checked={formValue?.IsActive}
                                            className="react-switch"
                                            disabled={formValue?.type === 'view' ? true : false}
                                        />
                                    </div>
                                    <div className=" col-auto col-lg-4">
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-3 d-flex justify-content-center">
                    {
                        formValue?.type === 'edit'
                            ? (
                                <button className="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={editDisable || !useredit}
                                >
                                    Update
                                </button>
                            )
                            : (
                                <button className="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={(formValue?.type === 'view' ? editDisable : false) || !useradd}
                                >
                                    Add
                                </button>
                            )
                    }
                    <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={onClearButton}>Clear</button>
                </div>
                <CommonFilter
                    columns={columns}
                    filterList={filterList}
                    searchDisabled={serchdisable}
                    getdata={getDataAll}
                    setlistdata={setGetListData}
                    searchvalue={searchvalue}
                    setSearchValue={setSearchValue}
                    searchby={searchby}
                    setSerachBy={setSerachBy}
                />
                <CustomTable
                    className={'last_two_column_freeze'}
                    columns={columns}
                    data={getDataList}
                    PdfExport={false}
                    ExportToExcel={false}
                    disabled={!userexport}
                />
            </form>
        </>
    )
}

export default APIMerchandisingHotel